import { render, staticRenderFns } from "./ModalCancelSurvey.vue?vue&type=template&id=28281d48&scoped=true"
import script from "./ModalCancelSurvey.vue?vue&type=script&lang=js"
export * from "./ModalCancelSurvey.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelSurvey.vue?vue&type=style&index=0&id=28281d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28281d48",
  null
  
)

export default component.exports